import Button from "components/Button";
import Status from "components/Status";
import moment from "moment";
import { Link } from "react-router-dom";
import { PAGE_SIZE } from "./PurchaseOrdersPage";
import { getOrderStatus, getReceiptStatus } from "./utils";

const DELIVERY_WARNING_DAYS = 7;

function getDeliveryDateWarning(po) {
  if (po.receipt_status === "full" || po.state === "draft") return null;

  const plannedDate = moment(po.date_planned).startOf("day");
  if (!plannedDate.isValid()) return null;

  const today = moment().startOf("day");
  const diffDays = plannedDate.diff(today, "days");

  if (diffDays < 0) {
    return { emoji: "🔴", className: "text-red-600 font-bold" };
  }

  if (diffDays <= DELIVERY_WARNING_DAYS) {
    return { emoji: "🟠", className: "text-orange-500 font-bold" };
  }

  return null;
}

const PurchaseOrderTableView = ({
  data,
  offset,
  q,
  receiptStatusFilter,
  setSearchParams,
}) => {
  const parsed = JSON.parse(data.supplierPos);
  const pos = parsed.records || [];
  const total = parsed.length || 0;

  return (
    <div className="overflow-auto relative text-sm">
      <table>
        <thead>
          <tr>
            <th className="px-6">订单号</th>
            <th className="px-6">状态</th>
            <th className="px-6">交付状态</th>
            <th className="px-6">关联</th>
            <th className="px-6 text-right">创建日期</th>
            <th className="px-6 text-right">交付日期</th>
            <th className="px-6 text-right">总价</th>
          </tr>
        </thead>
        <tbody>
          {pos.map((po) => {
            const warning = getDeliveryDateWarning(po);
            return (
              <tr
                key={po.id}
                className="border-y border-gray-100 dark:border-gray-700"
              >
                <td className="px-6">
                  <Link to={`${po.company_id.id}/${po.id}`}>{po.name}</Link>
                </td>
                <td className="px-6">
                  <Status status={getOrderStatus(po.state)} />
                </td>
                <td className="px-6">
                  <Status status={getReceiptStatus(po.receipt_status)} />
                </td>
                <td className="px-6">{po.so.display_name}</td>
                <td className="px-6 text-right">
                  {moment(po.create_date).format("YYYY-MM-DD")}
                </td>
                <td
                  className={`px-6 text-right ${warning ? warning.className : ""}`}
                >
                  {warning ? `${warning.emoji} ` : ""}
                  {moment(po.date_planned).format("YYYY-MM-DD")}
                </td>
                <td className="px-6 text-right">
                  {po.amount_total.toLocaleString(
                    {
                      style: "currency",
                      currency: po.currency_id.symbol,
                    },
                    { minimumFractionDigits: 2 },
                  )}
                  {po.currency_id.symbol}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="flex justify-end items-center space-x-2 sticky bottom-0 bg-gray-50 backdrop-blur dark:bg-gray-900/90 dark:backdrop-blur px-4 py-3 z-20">
        {offset > 0 ? (
          <Button
            prev
            onClick={() =>
              setSearchParams({
                offset: String(offset - PAGE_SIZE),
                q: q || "",
                receiptStatus: receiptStatusFilter || "ALL",
              })
            }
          />
        ) : null}
        <div>
          {total === 0 ? 0 : offset + 1} -{" "}
          {Math.min(offset + pos.length, total)} / {total}
        </div>
        {total > offset + PAGE_SIZE ? (
          <Button
            next
            onClick={() =>
              setSearchParams({
                offset: String(offset + PAGE_SIZE),
                q: q || "",
                receiptStatus: receiptStatusFilter || "ALL",
              })
            }
          />
        ) : null}
      </div>
    </div>
  );
};

export default PurchaseOrderTableView;
